<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <cook-logo v-if="!empresaExiste"></cook-logo>
    <div v-else>
      <nav-bar :logo-esquerda="true" :ocultar-pesquisa="true"></nav-bar>
      <logo-empresa></logo-empresa>
      <div class="conteudo cor-secundaria-bg">
        <h1 class="splash-texto-1 splash-cor-1" v-html="this.$i18n.locale === 'pt-BR' ? this.$store.state.empresa.splash_texto_1 : $t('splash_texto_1')" style="width: 100%"></h1>
        <p class="splash-texto-2 splash-cor-2" style="width: 100%" v-html="this.$i18n.locale === 'pt-BR' ? (this.$store.state.empresa.splash_texto_2.length > 200  ? this.$store.state.empresa.splash_texto_2.slice(0,200) + '...' : this.$store.state.empresa.splash_texto_2) : $t('splash_texto_2')"></p>
        <button @click="continuar()"
          class="btn waves-effect splash-texto-botao cor-primaria-text" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto;
    margin-right: auto; font-weight: bold">{{ this.$i18n.locale === 'pt-BR' ? (this.$store.state.empresa.aberto == 'S' ? this.$store.state.empresa.splash_texto_botao : "VEJA O CARDÁPIO") : $t('veja_o_cardapio') }}</div>
          </div>
        </button>

        <!-- Novo botão "MEUS PEDIDOS" -->
        <button v-if="this.$store.state.empresa.ocultar_botao_acompanhe_pedido !== 'S' && podeExibirModalRepetirPedido"
          @click="irParaMeusPedidos"
          class="btn waves-effect splash-texto-botao cor-primaria-text" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              {{ $t('acompanhe_seu_pedido') }}
            </div>
          </div>
        </button>

      </div>
      <div class="caixa-flutuante-inferior materialize-green center-block" v-if="this.$store.state.empresa.aberto == 'S'">
        <div class=" " style="padding: 0;margin-top: 7px">
          <img src="@/assets/papagaio.png" style="height: 30px" />
          <div class="texto-status">{{ $t('loja_online') }}</div>
        </div>
      </div>
      <caixa-flutuante-inferior
        v-else
        altura="40"
        class="materialize-red"
      >
        <div class="center-block">
          <div class="material-icons md-18 margin-status">fiber_manual_record</div>
          <div class="texto-status">{{ $t('loja_offline') }}</div>
        </div>
      </caixa-flutuante-inferior>
    </div>
    <ModalDefinirModoNavegacao v-if="this.$store.state.empresa.ocultar_acesso_convidado !== 'S'"></ModalDefinirModoNavegacao>
    <ModalRepetirPedido v-if="podeExibirModalRepetirPedido"></ModalRepetirPedido>
  </div>
</template>

<script>
import CaixaFlutuanteInferior from "../Widgets/CaixaFlutuanteInferior";
import ModalDefinirModoNavegacao from "../Widgets/ModalDefinirModoNavegacao";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";

import NavBar from "../Widgets/NavBar";
import CookLogo from "../Widgets/CookLogo";
import LogoEmpresa from "../Widgets/LogoEmpresa";

import {ObterLocalizacao} from "../../services/localizacao";
import {ChecarLogin, ObterClienteLogado} from "../../services/auth";
import ModalRepetirPedido from "../Widgets/ModalRepetirPedido";

export default {
  name: "Inicio",
  components: {
    ModalRepetirPedido,
    LogoEmpresa,
    CookLogo,
    NavBar,
    CaixaFlutuanteInferior,
    ModalDefinirModoNavegacao,
    Loading
  },
  data() {
    return {
      empresaExiste: false,
      lastError: null,
      isLoading: false,
      fullPage: true
    };
  },
  computed: {
    podeExibirModalRepetirPedido() {
      const empresa = this.$store && this.$store.state ? this.$store.state.empresa : null;
      const flag = empresa ? empresa.desativar_acompanhar_ultimo_pedido : null;
      return String(flag || "N").trim().toUpperCase() !== "S";
    }
  },
  mounted() {
      this.VerificarEmpresa().then(()=>{
        if(this.$store.state.pedido.itens.length == 0 && this.podeExibirModalRepetirPedido){
          this.ObterUltimoPedido();
        }
      });
      ObterLocalizacao();
      this.checarCupom();

  },
  methods: {
    checarCupom(){
      let cupom = '';
      try {
        if (this.$route.query.cupom) {
          this.isLoading = true;
          this.validarCupom();
        }
      }catch (e) {

      }
    },
    async validarCupom(){
      let localizacao  = localStorage.getItem('localizacao');
      await axios
        .get(this.$store.state.apiUrl + "cupom-desconto/validar?empresa=" + this.$store.state.empresa_url + "&subtotal="+ this.$store.getters.pedidoSubtotal.toFixed(2) +"&codigo_ativacao="+ this.$route.query.cupom +"&localizacao=" + localizacao)
        .then(res => {
          this.isLoading = false;
          if (res.data) {

            this.$store.state.cupom_desconto = this.$route.query.cupom;
            Swal.fire({
              title: 'Woohoo! 🤑',
              text: res.data,
              imageUrl: 'https://res.cloudinary.com/sirrus/image/upload/v1626188032/delivery/67577-reward-recieved_l7tias.gif',
              imageHeight: 150,
              backdrop: `
              rgba(65 105 225 / 85%)
              left top
              no-repeat`
            });

          }
        })
        .catch(error => {
          this.isLoading = false;
          Swal.fire({
            title: 'Ops...',
            text:error.response.data
          })

        });
    },
    async VerificarEmpresa() {
      this.isLoading = true;
      this.$store.commit("empresaUrl", this.$router.currentRoute.params.empresa);
      
      // Função para tentar buscar a empresa
      const buscarEmpresa = async (tentativa = 1) => {
        try {
          const res = await axios.get(
            this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url
          );
          
          if (res.data) {
            this.$store.commit("empresa", res.data);
            this.empresaExiste = true;
            this.isLoading = false;
            return true;
          }
          return false;
        } catch (error) {
          // Se for até a 5ª tentativa, tenta novamente
          if (tentativa < 5) {
            console.log(`Tentativa ${tentativa} de buscar empresa falhou, tentando novamente em 1.5s...`, error.response && error.response.status);
            await new Promise(resolve => setTimeout(resolve, 1500)); // Aguarda 1.5s
            return buscarEmpresa(tentativa + 1);
          }
          // Se falhar após 5 tentativas
          console.error("Erro ao buscar empresa após 5 tentativas:", error);
          this.lastError = error;
          this.isLoading = false;
          return false;
        }
      };

      const sucesso = await buscarEmpresa();
      
      if (!sucesso && !this.empresaExiste) {
        let reason = this.lastError ? (this.lastError.message || this.lastError) : 'Unknown';
        if (this.lastError && this.lastError.response) {
            reason += ` (Status: ${this.lastError.response.status})`;
        }
        reason += ` | Slug: ${this.$store.state.empresa_url}`;
        this.$router.push({
          path: '/404/nao-localizado',
          query: { retryPath: this.$route.fullPath, reason: reason }
        });
      }
    },
    async continuar(){
      this.isLoading = true;
      let status = await ChecarLogin(this.$store.state.apiUrl);
      this.isLoading = false;
      if (this.$store.state.empresa.bloquear_pedido === 'S' || status || this.$store.state.pedido.itens.length > 0)  {
        this.$router.push("/" + this.$store.state.empresa_url + "/menu");
      }else{
        // Se ocultar_acesso_convidado for "S", entra direto como convidado sem mostrar o modal
        if (this.$store.state.empresa.ocultar_acesso_convidado === 'S') {
          this.$router.push("/" + this.$store.state.empresa_url + "/menu");
        } else {
          $('#ModalDefinirModoNavegacao').modal('open')
        }
      }
    },
    async irParaMeusPedidos() {
      this.isLoading = true;
      this.isLoading = false;
      this.$router.push("/" + this.$store.state.empresa_url + "/login");
    },    
    async ObterUltimoPedido() {
  this.isLoading = true;

  if (!this.podeExibirModalRepetirPedido) {
    this.$store.state.exibir_popup_ultimo_pedido = false;
    this.isLoading = false;
    return;
  }

  let cliente = await ObterClienteLogado().catch((err) => {
    this.isLoading = false;
    console.error("Erro ao obter cliente:", err);
    return null; // Garantir que a função retorne null em caso de erro
  });

  if (cliente && this.$store.state.exibir_popup_ultimo_pedido) {
    // Validação do token
    const token = cliente.token_de_autenticacao;
    if (!token || token.length < 5) { // Ajuste o valor 5 conforme necessário
      console.error("Token inválido ou muito curto:", token);
      this.isLoading = false;
      return; // Interrompe a execução se o token for inválido
    }

    this.isLoading = true;

    try {
      const { data: response } = await axios.post(
        this.$store.state.apiUrl + "cliente/ultimo-pedido",
        {
          empresaId: this.$store.state.empresa.id,
          token: token,
        }
      );
      this.isLoading = false;

      let res = response.data;
      if (res && res.pedido != null) {
        this.$store.state.ultimo_pedido_cliente_logado = res.pedido;
        this.$store.state.exibir_popup_ultimo_pedido = false;
        $('#ModalRepetirPedido').modal('open');
      }
    } catch (err) {
      this.isLoading = false;
      console.error("Erro na requisição:", err.response ? err.response.data : err.message);
    }
  } else {
    this.isLoading = false;
  }
}
  }
};
</script>

<style scoped>
  @import '../../assets/css/paginas-inicio.css';
</style>

<style>
.conteudo .splash-texto-1, .conteudo .splash-texto-1 > p,
.conteudo .splash-texto-2, .conteudo .splash-texto-2 > p {
  margin: 5px 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginas/Inicio.vue